import { normalizeSettings } from './normalize/settings'
import { defaultPad, normalizePad } from './normalize/pad'
import { setUIPluginInstallations } from './installations'

export function makeSync(state) {
  return function sync(payload = {}) {
    state.value.user    = payload.user    ?? null
    state.value.wallets = payload.wallets ?? {}
    state.value.coins   = payload.coins   ?? {}
    state.value.coinsStats = payload.coinsStats ?? {}
    state.value.mints   = payload.mints   ?? {}
    state.value.mintsStats = payload.mintsStats ?? {}
    if (Object.prototype.hasOwnProperty.call(payload, 'uiPluginInstallations')) {
      setUIPluginInstallations(state, payload.uiPluginInstallations)
    }
    state.value.positionLifecycles = Array.isArray(payload.positionLifecycles) ? payload.positionLifecycles : []
    state.value.recentMarketTrades = Array.isArray(payload.recentMarketTrades) ? payload.recentMarketTrades : []
    state.value.liveReady = true
    state.value.pnl     = payload.pnl     ?? {}

    state.value.settings = normalizeSettings(payload.settings ?? state.value.settings)
    state.value.pad      = Object.prototype.hasOwnProperty.call(payload, 'pad')
      ? normalizePad(payload.pad)
      : defaultPad()
  }
}
